import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Slider from '@mygooder/react-slick';
import Card from './Card';
import { NextArrow, PrevArrow } from './../../shared/SliderArrows';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

const bwRewardsCardBg = require('../../../images/bw_rewards_card_bg.jpg');
const reachUsCardBg = require('../../../images/reach_us_card_bg.jpg');
const eventsCardBg = require('../../../images/events_card_bg.jpg');
const restaurantsCardBg = require('../../../images/restaurants_card_bg.jpg');

import find from 'lodash/find';

import './cardsslider.scss';

class CardsSlider extends React.Component {

  constructor(props) {
    super(props);
    this.handleAfterChange = this.handleAfterChange.bind(this);
    this.goToFirstCard = this.goToFirstCard.bind(this);
  }

  handleAfterChange(currentIndex) {

    const sliderCount = this.slider.props.children.length;
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;

    if(sliderCount < currentSlidesToShow) return;

    const minShowIndex = Math.floor(currentSlidesToShow/2);
    let maxShowIndex = (sliderCount - 1) - minShowIndex;
    if(currentSlidesToShow % 2 == 0) maxShowIndex++;
    

    if(currentIndex < minShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(minShowIndex); 
      }, 0);
      return;
    }

    if(currentIndex > maxShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(maxShowIndex); 
      }, 0);
      return;
    }
  }

  goToFirstCard() {
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;
    const minShowIndex = Math.floor(currentSlidesToShow/2);
    /* This defer prevents Key missing error when using inner slider into component lifecycle... :-| */
    let self = this;
    setTimeout(function(){ 
      if(!!self.slider) self.slider.slickGoTo(minShowIndex); 
    }, 0);
  }

  componentDidMount() {
    this.goToFirstCard();
  }

  componentWillUpdate(nextProps) {
    if(this.props.hotel != nextProps.hotel) {
      this.goToFirstCard();
    }
  }

  render() {

    let cardsData = [];

    // if(this.props.reservation.apiData.affiliation) {
    //   cardsData.push(
    //     this.props.reservation.apiData.affiliation.affiliated ? 
    //       {
    //         type: 'bwr', 
    //         url: this.props.reservation.apiData.affiliation.link , 
    //         backgroundImage: bwRewardsCardBg, 
    //         externalLink: true,
    //         buttonText: this.props.translate(`welcome.cards.bwr.button_text`),
    //         header: this.props.translate(`welcome.cards.bwr.header`),
    //         title: this.props.translate(`welcome.cards.bwr.title`),
    //         text: this.props.translate(`welcome.cards.bwr.text`)
    //       } : 
    //       {
    //         type: 'no_bwr', 
    //         url: this.props.reservation.apiData.affiliation.link, 
    //         backgroundImage: bwRewardsCardBg, 
    //         externalLink: true,
    //         buttonText: this.props.translate(`welcome.cards.no_bwr.button_text`),
    //         header: this.props.translate(`welcome.cards.no_bwr.header`),
    //         title: this.props.translate(`welcome.cards.no_bwr.title`),
    //         text: this.props.translate(`welcome.cards.no_bwr.text`)
    //       }
    //     );
    // }

    cardsData = cardsData.concat((this.props.hotel.apiData.additional_cards || []).map((additionalCard) => {
      return {
        type: 'additional',
        url: additionalCard.link,
        backgroundImage: additionalCard.picture,
        externalLink: true,
        buttonText: this.props.translate(`welcome.cards.additional.button_text`),
        header: null, // this.props.translate(`welcome.cards.additional.header`),
        title: additionalCard.title,
        text: additionalCard.text
      };
    }));
    
    cardsData = cardsData.concat([
      {
        type: 'restaurants', 
        url: `#/restaurants/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`,
        backgroundImage: restaurantsCardBg, 
        externalLink: false,
        buttonText: this.props.translate(`welcome.cards.restaurants.button_text`),
        header: this.props.translate(`welcome.cards.restaurants.header`),
        title: this.props.translate(`welcome.cards.restaurants.title`),
        text: this.props.translate(`welcome.cards.restaurants.text`, {hotel: this.props.hotel.apiData.name})
      },
      {
        type: 'events', 
        url: `#/events/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`, 
        backgroundImage: eventsCardBg, 
        externalLink: false,
        buttonText: this.props.translate(`welcome.cards.events.button_text`),
        header: this.props.translate(`welcome.cards.events.header`),
        title: this.props.translate(`welcome.cards.events.title`),
        text: this.props.translate(`welcome.cards.events.text`)
      },
      {
        type: 'reach', 
        url: `#/reach_us/${this.props.context ? `${this.props.context}/${this.props.token}` : this.props.token}`, 
        backgroundImage: reachUsCardBg, 
        externalLink: false,
        buttonText: this.props.translate(`welcome.cards.reach.button_text`),
        header: this.props.translate(`welcome.cards.reach.header`),
        title: this.props.translate(`welcome.cards.reach.title`),
        text: this.props.translate(`welcome.cards.reach.text`)
      }
    ]);

    const slickSettings = {
      afterChange: this.handleAfterChange,
      swipeToSlide: false,
      infinite: false,
      centerMode: true,
      variableWidth: false,
      prevArrow: <PrevArrow/>,
      nextArrow: <NextArrow/>,
      responsive: [ 
        { breakpoint: 768, settings: { initialSlide: 0, slidesToShow: 1, slidesToScroll: 1, arrows: false } }, 
        { breakpoint: 1024, settings: { initialSlide: 0, slidesToShow: 2, slidesToScroll: 1, arrows: true } }, 
        { breakpoint: 9999, settings: { initialSlide: 0, slidesToShow: 3, slidesToScroll: 1, arrows: true } } 
      ]
    };

    return (
      <Row>
        <Col xs={12} className="welcome-cardsslider-component">
          <Slider ref={c => this.slider = c } {...slickSettings}>
            {
              cardsData.map((cardData, index) => {
                return (<div key={index}>
                          <Card header={cardData.header} 
                                title={cardData.title} 
                                text={cardData.text} 
                                buttonText={cardData.buttonText} 
                                buttonLink={cardData.url} 
                                backgroundImage={cardData.backgroundImage}
                                externalLink={cardData.externalLink}/>
                        </div>)
              })
            }
          </Slider>
        </Col>
      </Row>
    );
  }
}

CardsSlider.displayName = 'PagesWelcomeCardsSlider';
CardsSlider.propTypes = {};
CardsSlider.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    token: state.commons.token,
    context: state.commons.context,
    hotel: state.hotel,
    reservation: state.reservation
  };
};

export default connect(mapStateToProps)(CardsSlider);



// WEBPACK FOOTER //
// ./components/pages/welcome/CardsSlider.js